export default "__VITE_ASSET__95d35624__"